function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.7544 54.2518C23.6714 56.4538 30.2884 56.5718 36.2324 54.5798C42.2244 52.5718 47.3774 48.5288 50.7434 43.1958C53.9724 38.0798 55.4364 31.9958 54.8874 26.0098L52.6164 26.2608C53.1094 31.7338 51.7674 37.2968 48.8134 41.9778C45.7264 46.8668 41.0004 50.5728 35.5084 52.4128C32.9254 53.2778 30.2314 53.7168 27.4994 53.7168C19.7074 53.7158 12.2084 50.1018 7.44044 44.0488L6.80244 43.2388H10.5834V40.9548H2.80444V49.1398H5.08744V44.7848L5.97444 45.8638C9.07144 49.6358 13.1464 52.5358 17.7544 54.2518Z",
  fill: "#333333"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.4917 4.606C24.9157 2.791 30.6197 2.847 35.9947 4.773C40.1777 6.273 43.9067 8.863 46.7807 12.263L47.4767 13.086L43.7687 13.085L43.7677 15.369L51.6457 15.372V7.598H49.3617V11.775L48.4807 10.739C45.3507 7.056 41.2997 4.251 36.7647 2.624C33.7477 1.542 30.6327 1 27.5127 1C24.5757 1 21.6357 1.48 18.7667 2.441C12.6917 4.476 7.49273 8.591 4.12773 14.029C0.892727 19.255 -0.506274 25.443 0.163726 31.511L2.42973 31.218C1.82573 25.67 3.11073 20.012 6.06973 15.231C9.15473 10.246 13.9217 6.472 19.4917 4.606Z",
  fill: "#333333"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M36.8726 32.2399C36.8726 27.9319 32.7816 27.1159 29.4946 26.4599C27.4056 26.0439 25.7566 25.7149 25.7566 24.4279C25.7566 23.6229 26.2966 22.6639 28.8706 22.6639C30.5646 22.6639 32.3596 23.1039 34.2136 23.9739L35.8746 19.9729C34.4346 19.2479 32.6336 18.7669 30.6326 18.5779L30.1796 18.5349V15.5059H27.1296V18.5719L26.6986 18.6329C22.5446 19.2149 20.0636 21.5109 20.0636 24.7719C20.0636 29.1079 24.1216 29.9529 27.3826 30.6319C29.5036 31.0729 31.1796 31.4219 31.1796 32.7579C31.1796 34.3479 28.9176 34.3479 28.0656 34.3479C25.9876 34.3479 23.5876 33.7299 21.6666 32.7149L19.8866 36.7429C21.5746 37.6589 24.1176 38.3089 26.6596 38.4629L27.1296 38.4909V41.5069H30.1796V38.3969L30.5936 38.3259C34.5246 37.6399 36.8726 35.3659 36.8726 32.2399Z",
  fill: "#333333"
});

var SvgRefundedValueIcon = function SvgRefundedValueIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRefundedValueIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/refunded_value_icon.31deb314.svg";
export { ForwardRef as ReactComponent };